import React, { Component } from 'react';
import { connect } from 'react-redux';
// utils
import { prepareEchannelPayload, Translations } from '../../../../utils';
// constant
import { FORM_REFS, CASE_CANCELLED, CASE_COMPLETED } from '../../../../constants';
// restClient
import { aemHostClient, eapiClient } from '../../../../restClient';
// children
import Dynamicform from '../../../common/Dynamicform/dynamicForm';
//action Creator
import { hideActionButton } from '../../../layouts/actions/actionCreator';
import { updateCase } from '../../../createAcase/actions/actionCreator';
import { blockUi, unBlockUi } from '../../../../actions/actionCreator';
//style
import './styles.css';


class CreateNewAccountEchannel extends Component {
  constructor(props) {
    super(props)
    this.state = {
      existingEntityData: []
    }
  }

  componentWillMount() {
    let apiURL = "/aemData/formData/json_create-echannel-reporting-page";
    aemHostClient(apiURL)
      .then(({ data }) => {
        document.title = `${Translations(data.par.page_title_mainTitle.pageHeading, this.props.lang.currentLang.lang, this.props.lang.translatedData)} - ${'HSBC GLCM'}`
        this.setState({ formJson: data });
      });
    let _caseId = Object.keys(this.props.cases)[0]
    let _url = "/entities/existing-organisations/" + _caseId;
    eapiClient(_url)
      .then(({ data }) => {
        this.setState({
          ...this.state,
          existingEntityData: data.responseData
        })
      });
  }

  componentDidMount() {
    this.props.hideActionButton();
  }

  getFormData = (formData) => {
    this.setState({ formData });
  }

  onFormSubmit = (event, apiUrl) => {
    this.props.blockUi();
    var case_Id;
    for (var key in this.props.cases) {
      if (this.props.cases[key].status !== CASE_CANCELLED && this.props.cases[key].status !== CASE_COMPLETED) {
        case_Id = this.props.cases[key].id;
        break;
      }
    }
    var requestData = prepareEchannelPayload({ ...this.state.formData }, case_Id);
    // var requestData = {...this.state.formData};
    // const {formData} = this.state;
    // const {newEchannel} = this.state.formData;
    // // preparing payload for Echannel
    // if(newEchannel === false) {
    //   const {other} = formData;
    //   if(!other) {
    //     requestData.profileOwner = {...formData.profileOwnerInPack};
    //     requestData.profileOwnerInPack = undefined;
    //     requestData.otherProfileOwner = undefined;
    //   }else {
    //     requestData.profileOwner = {
    //       name: formData.otherProfileOwner,
    //       value: Object.keys(this.props.cases)[0]
    //     }
    //     requestData.profileOwnerInPack = undefined;
    //     requestData.otherProfileOwner = undefined;
    //   }
    // }
    //
    // const caseId = requestData.profileOwner ? (requestData.profileOwner.value) : undefined;
    // requestData.caseId = caseId;

    eapiClient(apiUrl, {
      method: 'POST',
      data: JSON.stringify(requestData)
    })
      .then(({ data }) => {
        var { caseId } = data.responseData;
        this.props.updateCase(caseId, 'echannels', data.responseData);
        var key = window.sessionStorage.getItem("getCurrentDropDown");
        var keyType = window.sessionStorage.getItem("getCurrentDropDownType");
        window.sessionStorage.setItem('key' + key, data.responseData.id);
        window.sessionStorage.setItem('keyType' + keyType, data.responseData.eChannelType.name);
        this.props.history.goBack();
        this.props.unBlockUi();
      });
  }

  onFormCancel = () => {
    this.props.history.goBack();
  }

  renderFormGroups() {
    let formData = { newEchannel: false };
    const properties = {
      echannelId: this.props.match.params.echannelId,
      caseId: this.props.match.params.caseId,
      formData,
      existingEntityData: this.state.existingEntityData,
      editType: 'add-existing-echannel-to-case',
      pathname: this.props.history.location.pathname
    };
    if (this.state.formJson !== undefined && this.state.formJson.par.aemform_ !== undefined) {
      return (
        <Dynamicform mode="edit"
          properties={properties}
          url={FORM_REFS[this.state.formJson.par.aemform_.formRef]}
          getFormData={this.getFormData}
          onFormSubmit={this.onFormSubmit}
          onFormCancel={this.onFormCancel}
          lang={this.props.lang.currentLang.lang}
          translatedData={this.props.lang.translatedData}
          flag={this.props.lang.currentLangFlag.flag}
        />
      );
    }
  }

  render() {
    const pageTitle = this.state.formJson ? this.state.formJson.par.page_title_mainTitle : '';
    return (
      <div className="form-container">
        <div className="form-title">
          <h2 className="form-heading">
            {Translations(pageTitle.pageHeading, this.props.lang.currentLang.lang, this.props.lang.translatedData)}
          </h2>
          <p className="form-required-desc">
            {Translations(pageTitle.descriptionText, this.props.lang.currentLang.lang, this.props.lang.translatedData)}
          </p>
        </div>
        {this.renderFormGroups()}
      </div>
    );
  }
}


const mapStateToProps = (state, props) => {
  return {
    cases: state.cases,
    lang: state.lang
  }
}

const mapDispatchToProps = dispatch => {
  return {
    hideActionButton: () => {
      dispatch(hideActionButton())
    },
    updateCase: (caseId, productType, productData) => {
      dispatch(updateCase(caseId, productType, productData))
    },
    blockUi: () => {
      dispatch(blockUi())
    },
    unBlockUi: () => {
      dispatch(unBlockUi())
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(CreateNewAccountEchannel);



// WEBPACK FOOTER //
// ./src/components/CaseBody/ProductRequests/CaptureProductNewAccount/CreateNewAccountEchannel.js